import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import closeIcon from "../../../../src/assests/img/close-icon.svg";
import AuthManager from "../../../Common/AuthManager";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import "./Connection.css";
import SkeletonElement from "../../GMS/Category/Shimmer/SkeletonElement";

const MID_WAY_URL = process.env.REACT_APP_CONNECTION_API;

const ConnectionLogs = ({ logData, setViewLog, logId }) => {
  const [log, setLog] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const sortedLogs = logData?.split("\n\n")?.reverse() ?? [];
    setLog(sortedLogs);
  }, [logData]);

  const fetchLog = async () => {
    try {
      setLoading(true);
      const res = await ServiceWrapper.doGet(`${MID_WAY_URL}connection/log/${logId}`, null, null, AuthManager.getGmsToken());
      if (res?.data?.done) {
        const logsString = res?.data?.data?.logs ?? '';
        const sortedLogs = logsString?.split("\n\n")?.reverse() ?? [];
        setLog(sortedLogs);
      } else {
        toast.error("Log fetch failed.");
      }
    } catch (error) {
      console.error("fetchLog ~ error:", error)
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ps-0 form-header tw-flex tw-flex-col tw-h-[93%]">
      <div className="tw-px-3 tw-py-3 connection-container d-flex justify-content-between tw-sticky tw-top-0 tw-bg-white tw-z-10">
        <span className="mb-0 connection-text align-self-center fs-5">
          Logs
          <button
            type="button"
            className="btn btn-light btn-sm"
            style={{
              color: "#091caa",
              background: "none",
              border: "none",
              boxShadow: "none",
            }}
            onClick={() => fetchLog()}
          >
            <i className="fa fa-sync-alt" />
          </button>
        </span>
        <button
          className="mb-1 border-0 shadow-none align-self-center btn fw fw-light me-1"
          onClick={() => {
            setViewLog(false);
          }}
        >
          <img src={closeIcon} alt="Close icon" />
        </button>
      </div>

      <div className="rounded w-100 border-top tw-flex-grow tw-overflow-y-auto tw-pb-4 md:tw-pb-8 lg:tw-pb-12">
        {loading ? (
          <div className="p-3 border-bottom">
            <SkeletonElement type="title" />
          </div>
        ) : (
          log?.map((logItem, index) => (
            <div className="p-3 w-100 border-bottom" key={index}>
              <p className="text-break text-wrap">{logItem}</p>
            </div>
          ))
        )}
      <div className="tw-h-4 md:tw-h-8 lg:tw-h-12"></div>
      </div>
    </div>
  );
};

export default ConnectionLogs;